export const normalizeVariantFilterKey = (value) => String(value ?? "")
  .trim()
  .toLocaleLowerCase("en-US")
  .replace(/\s+/g, "")
  .replace(/[^a-z0-9_]/g, "");

export const normalizeVariantFilterValue = (value) => String(value ?? "")
  .trim()
  .toLocaleLowerCase("en-US");

export const getVariantFilterValue = (variant, wantedKey) => {
  const normalizedKey = normalizeVariantFilterKey(wantedKey);
  const entry = Object.entries(variant?.filter || {}).find(([key]) =>
    normalizeVariantFilterKey(key) === normalizedKey
  );
  return entry?.[1];
};

export const getDisplayFilterKey = (filterDefinition) =>
  normalizeVariantFilterKey(filterDefinition?._id?.name || filterDefinition?.name);

export const variantMatchesSelection = (variant, selection, ignoredKey = "") =>
  Object.entries(selection || {}).every(([key, value]) => {
    const normalizedKey = normalizeVariantFilterKey(key);
    if (!normalizedKey || normalizedKey === normalizeVariantFilterKey(ignoredKey)) return true;
    return normalizeVariantFilterValue(getVariantFilterValue(variant, normalizedKey)) ===
      normalizeVariantFilterValue(value);
  });

export const findVariantBySelection = (variants, selection) => {
  const safeVariants = Array.isArray(variants) ? variants.filter(Boolean) : [];
  return safeVariants.find((variant) => variantMatchesSelection(variant, selection)) || null;
};

export const isVariantOptionAvailable = (variants, key, value) => {
  const normalizedKey = normalizeVariantFilterKey(key);
  const wantedValue = normalizeVariantFilterValue(value);
  return (Array.isArray(variants) ? variants : []).some((variant) =>
    Number(variant?.quantity) > 0 &&
    normalizeVariantFilterValue(getVariantFilterValue(variant, normalizedKey)) === wantedValue
  );
};

export const selectVariantForOption = (variants, currentSelection, key, value) => {
  const normalizedKey = normalizeVariantFilterKey(key);
  const wantedValue = normalizeVariantFilterValue(value);
  const safeVariants = (Array.isArray(variants) ? variants : []).filter((variant) =>
    normalizeVariantFilterValue(getVariantFilterValue(variant, normalizedKey)) === wantedValue
  );
  if (!safeVariants.length) return null;

  const otherSelections = Object.entries(currentSelection || {}).filter(([selectionKey]) =>
    normalizeVariantFilterKey(selectionKey) !== normalizedKey
  );
  const score = (variant) => otherSelections.reduce((total, [selectionKey, selectionValue]) =>
    total + (normalizeVariantFilterValue(getVariantFilterValue(variant, selectionKey)) ===
      normalizeVariantFilterValue(selectionValue) ? 1 : 0), 0);

  return safeVariants
    .map((variant, index) => ({ variant, index, available: Number(variant?.quantity) > 0, score: score(variant) }))
    .sort((left, right) =>
      Number(right.available) - Number(left.available) || right.score - left.score || left.index - right.index
    )[0]?.variant || null;
};

export const getActualFilterValues = (variants, key) => {
  const values = new Map();
  (Array.isArray(variants) ? variants : []).forEach((variant) => {
    const value = getVariantFilterValue(variant, key);
    const normalizedValue = normalizeVariantFilterValue(value);
    if (normalizedValue && !values.has(normalizedValue)) values.set(normalizedValue, value);
  });
  return [...values.values()];
};
